if (!customElements.get('upcoming-events')) {
  customElements.define('upcoming-events', class UpcomingEvents extends HTMLElement {
    constructor() {
      super();

      this.renderEventCards();
    }

    buildEventCard(data) {
      if (data.isRegistrationClosed) return '';

      return `<div class="event-date-card ${ data.isHighlighted ? 'is-highlighted' : '' }">
        <div class="event-date-card-inner">
          <div class="event-date-card__info">
            <h5 class="event-date-card__title">${ data.title }</h5>
            <p class="event-date-card__start-date">${ data.startDate }</p>
            <p class="event-date-card__registration-close-date">Registrations close: ${ data.regCloseDate }</p>
            <a ${ data.isRegistrationClosed ? 'disabled' : `href="${ data.url }?program=${ data.slug }"` } class="pd-button ${ data.isHighlighted ? 'pd-button--black' : 'pd-button--gradient' } ${ data.slug }">
              <span class="pd-button__text">Select date</span>
            </a>
          </div>
          ${ data.isHighlighted && data.regCloseDate ? `<div class="event-date-card__count-down">
            <span class="event-date-card__count-down__label">${ data.isRegistrationClosed ? 'Registration closed' : 'Registrations close in:' }</span>
            ${ !data.isRegistrationClosed ? `<div class="event-date-card__count-down__date" data-event-count-down-time="${ data.regCloseDateRaw }"></div>` : '' }
          </div>` : '' }
        </div>
      </div>`;
    }

    produceEventData(data) {
      const nowTime = new Date().getTime();
      const startDate = new Date(data.start_date);
      const startDateTime = startDate.getTime();

      if (startDateTime >= nowTime) {
        let regCloseDate = new Date(data.registration_close_date);
        regCloseDate.setHours(23, 59, 59, 999);

        return {
          url: `${ window.coreHostUrl }/select-program/${ startDate.getFullYear() }-${ ('0' + (startDate.getMonth() + 1)).slice(-2) }-${ ('0' + startDate.getDate()).slice(-2) }`,
          startDateTime,
          startDate: data.start_date,
          startDateRaw: startDate,
          regCloseDate: `${ regCloseDate.getDate() } ${ formatMonth(regCloseDate.getMonth()) }`,
          regCloseDateRaw: regCloseDate,
          isHighlighted: regCloseDate.getTime() - nowTime < (24 * 60 * 60 * 1000) * 7,
          isRegistrationClosed: regCloseDate.getTime() <= nowTime
        };
      }

      return false;
    }

    renderEventCards() {
      const ELM_programs = this.querySelectorAll('[data-program-json]');

      if (!ELM_programs || !ELM_programs.length) return;

      let events = [];

      ELM_programs.forEach(ELM_program => {
        const { programJson, title, takeFirst } = ELM_program.dataset;

        if (programJson) {
          const programData = JSON.parse(programJson);

          if (takeFirst && programData) {
            let data = null;
            const now = new Date();

            for (let i = 0; i < programData.schedules.length; i++) {
              const registrationCloseDate = new Date(programData.schedules[i].registration_close_date);
              registrationCloseDate.setHours(23, 59, 59, 999);

              if (registrationCloseDate.getTime() >= now.getTime()) {
                data = this.produceEventData(programData.schedules[i]);
                break;
              }
            }

            if (data) {
              ELM_program.innerHTML = this.buildEventCard({
                ...data,
                title,
                slug: programData.program_slug
              });
            }

            return;
          }

          programData?.schedules?.forEach(item => {
            const data = this.produceEventData(item);

            if (!data) return;

            events.push({
              ...data,
              title,
              slug: programData.program_slug
            });
          });
        }
      });

      if (!events.length) return;

      const html = events
        .sort((a, b) => a.startDateTime - b.startDateTime)
        .map(event => this.buildEventCard(event))
        .join('');

      this.querySelectorAll('[data-container]')?.forEach(ELM_container => {
        ELM_container.innerHTML = html;
      });

      document.dispatchEvent(new CustomEvent('upcomingEvents::rendered', {
        detail: {
          element: this
        }
      }));
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.upcoming-dates__events.tablet-down');

    if (!container) return;

    let isMouseDown = false;
    let startX;
    let scrollLeft;

    container.addEventListener('mousedown', (e) => {
      isMouseDown = true;
      container.style.cursor = 'grabbing';
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener('mouseleave', () => {
      isMouseDown = false;
      container.style.cursor = 'grab';
    });

    container.addEventListener('mouseup', () => {
      isMouseDown = false;
      container.style.cursor = 'grab';
    });

    container.addEventListener('mousemove', (e) => {
      if (!isMouseDown) return;

      e.preventDefault();

      const x = e.pageX - container.offsetLeft;
      const walk = x - startX;
      container.scrollLeft = scrollLeft - walk;
    });
  });
}